import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { CommonService } from '../../providers/common.service';
import { MatDialog } from '@angular/material/dialog';
import { DownloadUrl } from '../../models/downloadurl';

@Component({
    selector: 'app-downloadsmodule',
    templateUrl: './downloads.html',
    styleUrls: ['../bleclassmodule/bleclassmodule.css']
  })

export class DownloadsComponent {

  downloadAndroid: DownloadUrl[] = [
    new DownloadUrl('./../../downloads/SGConnect/1.0.0/Android/sgconnectapi.aar', '1.0.0')
  ];

  downloadiOS: DownloadUrl[] = [
    // new DownloadUrl('./../../assets/Downloads/1.0.0/iOS/SGConnectAPI.framework.zip', '1.0.0'),
    // new DownloadUrl('./../../assets/Downloads/1.0.1/iOS/SGConnectAPI.framework.zip', '1.0.1 (Swift5 compatible)'),
    // new DownloadUrl('./../../assets/Downloads/1.0.2/iOS/SGConnectAPI.framework.zip', '1.0.2 (Swift5.2 compatible)'),
    // new DownloadUrl('./../../assets/Downloads/1.0.3/iOS/SGConnectAPI.framework.zip', '1.0.3 (Swift5.3 compatible)'),
    new DownloadUrl('./../../downloads/SGConnect/1.0.4/iOS/SGConnectAPI.framework.zip', '1.0.4 (Swift5.3.1 compatible)'),
    new DownloadUrl('./../../downloads/SGConnect/1.0.4.1/iOS/SGConnectAPI.framework.zip', '1.0.4.1 (Swift5.3.2 compatible)'),
    new DownloadUrl('./../../downloads/SGConnect/1.0.5/iOS/SGConnectAPI.framework.zip', '1.0.5 (Swift5.4 compatible)'),
    new DownloadUrl('./../../downloads/SGConnect/universal/SGConnectAPI.xcframework.zip', 'Universal'),
  ];

  downloadCordova: DownloadUrl[] = [
    new DownloadUrl('./../../downloads/SGConnect/1.0.0/Cordova/cordova-plugin-sgconnectapiplugin.zip', '1.0.0')
  ];

  downloadEdgeAndroid: DownloadUrl[] = [
    new DownloadUrl('./../../downloads/SGConnectEdge/1.0.0/Android/sgconnectedge.aar', '1.0.0')
  ];

  downloadEdgeiOS: DownloadUrl[] = [
    new DownloadUrl('./../../downloads/SGConnectEdge/1.0.0/iOS/SGConnectEdge.framework.zip', '1.0.0'),
  ];

  downloadPlatforms: DownloadUrl[][] = [this.downloadAndroid, this.downloadiOS, this.downloadCordova];
  downloadEdgePlatforms: DownloadUrl[][] = [this.downloadEdgeAndroid, this.downloadEdgeiOS];

  constructor(private commonsvc: CommonService,
    public router: Router,
    public dialog: MatDialog) {
  }

}
